// extracted by mini-css-extract-plugin
export default {"auth_block":"auth_auth_block__VHR4O","form_wrapper":"auth_form_wrapper__Vv78H","restore_password":"auth_restore_password__ozE0D"};